import React from 'react';

import { defineMessages } from 'react-intl';

import DefaultLayout from '~/layout/components/DefaultLayout';
import CompressionGuideLayout from '~/staticPages/components/CompressionGuideLayout';

import createPage from '../registry';
import CuralateUgcSnippet from '../src/shared/utils/CuralateUgcSnippet';

const seo = defineMessages({
  title: {
    id: 'site_seo_title.compression_guide',
    defaultMessage: 'Compression Guide',
  },
  description: {
    id: 'site_seo_description.compression_guide',
    defaultMessage: 'Compression Guide',
  },
});

const CompressionGuide = () => {
  return (
    <>
      <CuralateUgcSnippet />
      <DefaultLayout title={seo.title} description={seo.description}>
        <CompressionGuideLayout />
      </DefaultLayout>
    </>
  );
};

export default createPage(CompressionGuide, {
  resourceBundles: ['compression_guide', 'compression_guide_overlay'],
  prefetchAssets: [
    'Compression_Guide_hero_vid_d_16',
    'Compression_Guide_hero_vid_m_16',
    'compression_guide_seamless_photo_carousel_1d',
    'compression_guide_seamless_photo_carousel_2d',
    'compression_guide_seamless_photo_carousel_3d',
    'compression_guide_seamless_photo_carousel_4d',
    'compression_guide_seamless_photo_carousel_1m',
    'compression_guide_seamless_photo_carousel_2m',
    'compression_guide_seamless_photo_carousel_3m',
    'compression_guide_seamless_photo_carousel_4m',
    'compression_guide_mesh_me_photo_carousel_1d',
    'compression_guide_mesh_me_photo_carousel_2d',
    'compression_guide_mesh_me_photo_carousel_3d',
    'compression_guide_mesh_me_photo_carousel_4d',
    'compression_guide_mesh_me_photo_carousel_1m',
    'compression_guide_mesh_me_photo_carousel_2m',
    'compression_guide_mesh_me_photo_carousel_3m',
    'compression_guide_mesh_me_photo_carousel_4m',
    'compression_guide_overlay_Mesh_Me_fabric_card_d',
    'compression_guide_overlay_seamless_fabric_card_d',
  ],
});
